module.exports = "/fonts/Trial-Proofer.ttf?773e3b62e84412d3c976053b338f283a";